import { cn } from "@/lib/utils";

/**
 * Sabine's portrait, as it appears in the support dialog: the hero tile of the
 * welcome view and the small round one beside anything she says. Two sizes, one
 * photo and one crop, so her face is framed the same everywhere.
 */
const SIZES = {
  hero: "h-[68px] w-[68px] rounded-2xl shadow-md ring-2 ring-offset-1",
  inline: "h-7 w-7 rounded-full shadow-sm ring-1",
};

/** @param {{ size?: keyof SIZES, className?: string }} props */
export default function SabineAvatar({ size = "inline", className }) {
  return (
    <div
      className={cn(
        "shrink-0 overflow-hidden ring-orange-200",
        SIZES[size] || SIZES.inline,
        className,
      )}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/sabine/sabine-v2-playback-2.jpg"
        alt="Sabine"
        className="h-full w-full scale-110 object-cover object-top"
      />
    </div>
  );
}
